import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface SubscriptionPlanTileStyles {
  container: Styles
  trial: Styles
  trialBottom: Styles
  radioButton: Styles
  radioButtonSVG: Styles
  currency: Styles
  discountedCurrency: Styles
  label: Styles
  description: Styles
  description2: Styles
  planName: Styles
  strikedPrice: Styles
}

interface SubscriptionPlanTileProps {
  isTileSelected: boolean
  isDesktop: boolean
  hasDiscountedPrice: boolean
}

export const useStyles = createUseStyles<SubscriptionPlanTileStyles, SubscriptionPlanTileProps>((theme) => {
  return {
    container: {
      position: 'relative',
      paddingTop: theme.calcUnit(theme.spacing.s3),
      paddingRight: theme.calcUnit(theme.spacing.s3),
      paddingBottom: theme.calcUnit(theme.spacing.s3),
      paddingLeft: theme.calcUnit(theme.spacing.s3),
      // Ux asked to keep this one commented
      // We will need this when we decide to go with 2col for plan selection on desktop
      // ...theme.breakpoint.up('lg', {
      //   width: theme.calcUnit(202),
      // }),
    },
    trial: ({ isTileSelected }) => ({
      backgroundColor: '#3388FF',
      paddingTop: theme.calcUnit(theme.spacing.s1),
      paddingRight: theme.calcUnit(theme.spacing.s2),
      paddingBottom: theme.calcUnit(theme.spacing.s1),
      paddingLeft: theme.calcUnit(theme.spacing.s2),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      position: 'absolute',
      top: isTileSelected ? theme.calcUnit(-12) : theme.calcUnit(-12),
      right: theme.calcUnit(theme.spacing.s2),
      color: theme.colors.webInverseTextColor,
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(16),
      textAlign: 'center',
      textTransform: 'uppercase',
      ...theme.useFontStyles('PFF Sans', '600', 'normal'),
    }),
    trialBottom: () => ({
      backgroundColor: '#FFD300',
      paddingTop: theme.calcUnit(theme.spacing.s1),
      paddingRight: theme.calcUnit(theme.spacing.s2),
      paddingBottom: theme.calcUnit(theme.spacing.s1),
      paddingLeft: theme.calcUnit(theme.spacing.s2),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      position: 'absolute',
      bottom: theme.calcUnit(20),
      right: theme.calcUnit(20),
      color: theme.colors.textColor,
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(16),
      textAlign: 'center',
      ...theme.useFontStyles('PFF Sans', '600', 'normal'),
    }),
    radioButtonSVG: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: theme.calcUnit(theme.spacing.s2),
    },
    currency: {
      fontWeight: '700',
      fontFamily: 'Roboto, sans-serif',
      fontSize: theme.calcUnit(15),
      lineHeight: theme.calcUnit(24),
      marginRight: theme.calcUnit(2),
      opacity: ({ hasDiscountedPrice }) => (hasDiscountedPrice ? 0.7 : 1),

      // @ts-expect-error
      ...theme.breakpoint.up('lg', {
        fontSize: theme.calcUnit(17),
      }),
    },
    discountedCurrency: {
      fontWeight: '700',
      fontFamily: 'Roboto, sans-serif',
      fontSize: theme.calcUnit(15),
      lineHeight: theme.calcUnit(24),
      marginRight: theme.calcUnit(2),

      // @ts-expect-error
      ...theme.breakpoint.up('lg', {
        fontSize: theme.calcUnit(17),
      }),
    },
    planName: {
      fontWeight: '600',
      fontStyle: 'normal',
      fontFamily: 'Roboto',
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(24),
      paddingLeft: theme.calcUnit(theme.spacing.s2),
    },
    radioButton: {
      opacity: '0',
    },
    label: {
      fontWeight: '800',
      fontFamily: 'Roboto, sans-serif',
      fontSize: theme.calcUnit(20),
      lineHeight: theme.calcUnit(24),
      // @ts-expect-error
      ...theme.breakpoint.up('lg', {
        fontSize: theme.calcUnit(28),
      }),
    },
    description: {
      fontWeight: '400',
      fontFamily: 'Roboto, sans-serif',
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(20),
      marginTop: theme.calcUnit(theme.spacing.s1),
      // @ts-expect-error
      ...theme.breakpoint.up('lg', {
        marginLeft: theme.calcUnit(0),
      }),
    },
    description2: {
      fontWeight: '400',
      fontFamily: 'Roboto, sans-serif',
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(20),
      // @ts-expect-error
      ...theme.breakpoint.up('lg', {
        marginLeft: theme.calcUnit(0),
      }),
    },
    strikedPrice: {
      marginRight: theme.calcUnit(theme.spacing.s2),
      opacity: 0.7,
    },
  }
})
